// Shared entrance-animation helpers, consolidated from the near-identical
// copies previously duplicated in Orders.js, Kpitracker.js, farmDashboard.js,
// FarmInbox.js, FlierTargeting.js, siteStats.js and trayManager.js.
//
// Keyframes (td-fade-up / td-fade-down / td-scale-in) live in farmDashboard.css.

export const stagger = (i, key = 'td-fade-up', base = 20, step = 45, dur = 260) => ({
  animation: `${key} ${dur}ms ease-out`,
  animationDelay: `${base + i * step}ms`,
  animationFillMode: 'both',
});

export const gridStagger = (row, col, cols, key = 'td-fade-up', base = 20, step = 25) =>
  stagger(row * cols + col, key, base, step);

// Cards used to lift on hover by writing inline transform/shadow; hover is a
// quiet border tint in CSS now (.chart-container:hover etc.), so these are
// kept as no-ops for the call sites that still pass them.
export const onEnter = () => {};
export const onLeave = () => {};
